import angular from 'angular';
import template from './horizontalNavigationBar.component.html';

export default angular.module('shared').component('horizontalNavigationBar', {
    template: template,
    controller(navigationService, textResources) {
        var vm = this;
        vm.navigationService = navigationService;
        vm.navigationService.getNavigationItems();

        vm.options = {
            showSearchIcon: false,
            initialSearchOpen: false,
            searchPlaceholder: textResources.navigationSearchPlaceHolder,
            searchSref: null
        };
    }
});



// WEBPACK FOOTER //
// ./modules/shared/components/horizontalNavigationBar/horizontalNavigationBar.component.js